import { render, staticRenderFns } from "./MContentsTitle.vue?vue&type=template&id=187b5a97&"
import script from "./MContentsTitle.vue?vue&type=script&lang=ts&"
export * from "./MContentsTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports